<template>
  <v-progress-circular
    :color="color"
    :size="size"
    :width="5"
    :indeterminate="indeterminate"
    :model-value="$attrs.value || 0"
  />
</template>

<script>
/**
 * Default Loader
 * @displayName AppLoader
 */
export default {
  name: 'AppLoader',
  props: {
    /**
     * Set the indeterminate prop of v-progress-circular component
     * @see https://vuetifyjs.com/en/api/v-progress-circular/#props-indeterminate
     */
    indeterminate: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    size () {
      return this.small ? 50 : 80
    },
  },
}
</script>
